import React from 'react';
import { motion } from 'framer-motion';
import { Linkedin, Mail } from 'lucide-react';
import { portfolioData } from '../data/mock';

const Footer = () => {
  const { identity, footer } = portfolioData;
  
  return (
    <footer className="py-16 px-6 md:px-12 relative">
      <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-48 h-px" style={{ background: 'rgba(180, 195, 220, 0.1)' }} />
      
      <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }} className="max-w-4xl mx-auto flex flex-col items-center text-center">
        <img src="https://customer-assets.emergentagent.com/job_9473450d-8fdf-465d-8892-552dd8ecfad1/artifacts/hz3lxj60_image.png" alt="Symbol" className="w-10 h-10 mb-6 opacity-60 hover:opacity-80 transition-opacity duration-300" />
        
        <p className="mb-1" style={{ fontFamily: 'Cinzel, serif', color: 'rgba(220, 230, 245, 0.9)', fontSize: '1rem' }}>{identity.name}</p>
        <p className="mb-4" style={{ fontFamily: 'DM Mono, monospace', color: 'rgba(150, 170, 200, 0.6)', fontSize: '0.75rem', letterSpacing: '0.2em' }}>{identity.alias}</p>
        
        {/* Social links */}
        <div className="flex items-center gap-6 mb-6">
          <a href={`mailto:${identity.email}`} className="email-link" style={{ color: 'rgba(180, 195, 220, 0.7)' }}>
            <Mail className="w-5 h-5" />
          </a>
          <a href={identity.linkedin} target="_blank" rel="noopener noreferrer" className="email-link" style={{ color: 'rgba(180, 195, 220, 0.7)' }}>
            <Linkedin className="w-5 h-5" />
          </a>
        </div>
        
        <p className="mb-6" style={{ fontFamily: 'DM Mono, monospace', color: 'rgba(150, 170, 200, 0.5)', fontSize: '0.7rem' }}>{footer.year}</p>
        
        <p className="max-w-md" style={{ fontFamily: 'EB Garamond, serif', fontStyle: 'italic', color: 'rgba(150, 170, 200, 0.6)', fontSize: '0.95rem', lineHeight: '1.7' }}>
          "{footer.quote}"
        </p>
      </motion.div>
    </footer>
  );
};

export default Footer;
